<div class="dashboard-container">
    <div *ngFor="let tile of tiles" class="tile">
        <div class="tile-info-container">
            <app-svg-icon [iconName]="tile.iconName" [isStaticSvg]="true" class="tile-icons"></app-svg-icon>
            <span class="ibc-customer-heading-h6-bold-primary-dark">{{tile.tileName}}</span>
            <span class="ibc-customer-heading-regular">{{tile.description}}</span>
        </div>
        <div class="action-btn-container">
            <button mat-button class="mat-button-lg ibc-secondary-default-button login-btn" (click)="onTileBtnCick(tile.actionButtonTitle)">{{tile.actionButtonTitle}}</button>
        </div>
    </div>
  </div>
